import { GithubAuthDataService } from '../service/github-auth-data.service';
import { LuigiThemingService } from '../service/luigiNodes/luigi-theming.service';
import { VPNService } from '../service/luigiNodes/vpn.service';
import { RagChatService } from '../service/rag-chat.service';
import { alertInitializer } from './alert-initializer';
import { initAnalyticsTracker } from './analytics-tracker-initializer';
import { browserCheckInitializer } from './browser-check-initializer';
import { initJoule } from './joule-initializer';
import { initNotifications } from './notifications-initializer';
import { initRagChat } from './rag-chat-initializer';
import { initializeSessionRefreshHandler } from './session-refresh-handler-initializer';
import { initTheme } from './theme-initializer';
import { checkIfInVPN } from './vpn-initializer';
import {
  ApplicationRef,
  EnvironmentInjector,
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AuthService,
  ConfigService,
  LuigiCoreService,
} from '@openmfp/portal-ui-lib';

export const provideDxpInitializers = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideAppInitializer((): void => {
      initAnalyticsTracker()();
    }),
    provideAppInitializer((): void => {
      initTheme(inject(LuigiThemingService), inject(ActivatedRoute))();
    }),
    provideAppInitializer((): void => {
      checkIfInVPN(inject(VPNService))();
    }),
    provideAppInitializer((): void => {
      initializeSessionRefreshHandler(
        inject(GithubAuthDataService),
        inject(AuthService),
      )();
    }),
    provideAppInitializer((): void => {
      initJoule(
        inject(ConfigService),
        inject(AuthService),
        inject(ActivatedRoute),
        inject(LuigiCoreService),
      )();
    }),
    provideAppInitializer((): void => {
      initRagChat(
        inject(AuthService),
        inject(ConfigService),
        inject(RagChatService),
        inject(ApplicationRef),
        inject(EnvironmentInjector),
      )();
    }),
    provideAppInitializer(() => {
      initNotifications();
    }),
    provideAppInitializer(() => {
      browserCheckInitializer();
    }),
    provideAppInitializer(() => {
      alertInitializer().catch();
    }),
  ]);
